import ClickOutside from 'react-click-outside';
import colors from 'shared-assets/lib/colors';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

const PopOverWrapper = styled.div`
  position: relative;
`;
const PopOver = styled.div`
  position: absolute;
  z-index: 2;

  button {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
    outline: none;

    svg {
      fill: ${colors.secondary};
      height: 0.75rem;
      width: 0.75rem;
    }
  }
`;

export default class WithPopoverOnClick extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopOverOpen: false,
    };
  }

  togglePopover(value) {
    this.setState({
      isPopOverOpen: value,
    });
  }

  render() {
    return (
      <PopOverWrapper
        className="popover-wrapper"
        onClick={() => {
          this.props.onClick();
          this.togglePopover(true);
        }}
      >
        <span
          data-testid="popover-trigger"
          style={{ cursor: 'pointer', ...this.props.popOverTriggerStyles }}
        >
          {this.props.children}
        </span>
        <If condition={this.state.isPopOverOpen}>
          <ClickOutside
            onClickOutside={() => {
              this.togglePopover(false);
              this.props.onClose();
            }}
          >
            <PopOver>
              <button
                aria-label="close"
                type="button"
                onClick={e => {
                  e.stopPropagation();
                  this.togglePopover(false);
                  this.props.onClose();
                }}
                style={this.props.popOverStyle}
              >
                <SVG src={require('shared-assets/assets/icons/close.svg')} />
              </button>
              {this.props.render}
            </PopOver>
          </ClickOutside>
        </If>
      </PopOverWrapper>
    );
  }
}
WithPopoverOnClick.defaultProps = {
  onClick: () => {},
  onClose: () => {},
  popOverStyle: {},
  popOverTriggerStyles: {},
};

WithPopoverOnClick.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  render: PropTypes.node.isRequired,
  popOverTriggerStyles: PropTypes.object,
  popOverStyle: PropTypes.object,
};
